import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
        error: null,
        initialized: false,
        messages: [],
        dialog: null
};

const initStart = (state, action) => {
    return updateObject( state, { initialized: false } );
}

const initSuccess = (state, action) => {
    return updateObject( state, { initialized: true } );
}

const initFail = (state, action) => {
    console.trace();
    return updateObject( state, {
        error: 'App could not be initialized',
        initialized: false
    });
}
const appError = (state, action) => {
    return updateObject( state, {
        error: action.error
    });
}
const addMessage = (state, action) => {
    let newState = {...state};
    if(action.payload.target === 'messages' || action.payload.target === 'both') {
        let newMessages = state.messages.slice();
        newMessages.push(action.payload.message);
        newState = updateObject(newState, { 
            messages: newMessages
        });
    }
    if(action.payload.target === 'dialog' || action.payload.target === 'both') {
        newState = updateObject(newState, { 
            dialog: action.payload.message
        });
    }
    return newState;
    
}


const reducer = ( state = initialState, action) => {
    switch (action.type) {
        case actionTypes.INIT_START: return initStart(state, action);
        case actionTypes.INIT_SUCCESS: return initSuccess(state, action);
        case actionTypes.INIT_FAIL: return initFail(state, action);
        case actionTypes.APP_ERROR: return appError(state, action);
        case actionTypes.APP_ADD_MESSAGE: return addMessage(state, action);
        case actionTypes.APP_REMOVE_DIALOG: return updateObject(state, { dialog: null});
        default: 
            return state;
    }
}

export default reducer;